import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll to top on every new route navigation (PUSH/REPLACE).
 * When the user goes back/forward (POP), we let the browser restore
 * the previous scroll position naturally.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return; // back/forward: keep native behavior
    // Wait one frame so the new page has mounted before scrolling
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } catch {
        window.scrollTo(0, 0);
      }
    });
  }, [pathname, navType]);

  return null;
}
